// fix issue with styled-jsx complaining about _JSXStyle not being defined,
// see https://stackoverflow.com/a/66285652
// eslint-disable-next-line @typescript-eslint/no-var-requires
const _JSXStyle = require("styled-jsx/style").default;
if (typeof global !== "undefined") {
  Object.assign(global, { _JSXStyle });
}
